import createApi from 'api/createApi';
import qs from 'query-string';

export const tags = {
	person: 'mw/person',
};

export const personApi = createApi({
	reducerPath: 'mw/personApi',

	endpoints: (builder) => ({
		person: builder.mutation({
			query: (body) => ({
				method: 'GET',
				url: `/mw/person?${qs.stringify(body)}`,
			}),
			providesTags: [tags.person],
		}),
	}),
});

export const {
	person,
} = personApi.endpoints;

export default personApi;